import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './Subscription.css';
import MainNavbar from "../MainNavbar";
import { useContext } from "react";
import AlertContext from "../../../contexts/AlertContext";

const Subscription = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const { showAlert } = useContext(AlertContext);

  // Fetch plans from backend
  useEffect(() => {
    axios.get('https://back.varankal.com/api/plans', {
      withCredentials: true
    })
      .then(res => {
        setPlans(res.data);
        setLoading(false);
      })
      .catch(err => {
        setError('Failed to load subscription plans.');
        setLoading(false);
      });
  }, []);

  const handlePurchase = async (planName) => {
    const storedUser = localStorage.getItem('user');
    if (!storedUser) {
      showAlert("User info not found. Please log in again.", "error");
      return;
    }

    let user;
    try {
      user = JSON.parse(storedUser);
    } catch (err) {
      showAlert("Stored user data is corrupted. Please log in again.", "error");
      localStorage.removeItem('user');
      return;
    }

    const userId = user?._id;

    if (!userId) {
      showAlert("User ID is missing. Please log in again.", "error");
      return;
    }

    try {
      await axios.post(
        'https://back.varankal.com/api/payments/purchase',
        {
          userId,
          planName,
          paymentMethod: 'manual'
        },
        { withCredentials: true }
      );

      const plan = plans.find(p => p.name === planName);
      if (!plan || !plan._id) {
        showAlert("Unable to find plan ID for subscription.");
        return;
      }

      const response = await axios.post(
        'https://back.varankal.com/api/plans/subscribe',
        {
          userId,
          planId: plan._id
        }
      );

      showAlert(`${planName} Plan Subscribed Successfully!`);
    } catch (error) {
      const errorMsg = error.response?.data?.error || 'Error while purchasing the plan.';
      if (errorMsg.includes('already purchased')) {
        showAlert(`You already have the ${planName} plan active.`);
      } else {
        showAlert(errorMsg);
      }
    }
  };

  return (
    <>
      <MainNavbar />
      <div className="subscription-container1">
        <h2 className="subscription-title1">Varankal Premium Membership – Find Your True Match Faster</h2>

        {loading && <p style={{ textAlign: 'center' }}>Loading plans...</p>}
        {error && <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>}

        <div className="subscription-grid1">
          {!loading && !error && plans.length === 0 && (
            <p style={{ textAlign: 'center', width: '100%' }}>No subscription plans found.</p>
          )}

          {plans.map((plan, index) => (
            <div key={plan._id} className="subscription-card1">


              <h3 className="plan-name1">{plan.name}</h3>
              <p className="plan-price1">₹{plan.price}</p>
              <p className="plan-duration1">Duration: {plan.durationInMonths} Months</p>

              {plan.discount && (
                <p className="plan-discount1">Discount: {plan.discount}</p>
              )}

              <ul className="plan-features1">
                {plan.features.map((feature, i) => (
                  <li key={i} className="plan-feature-item">
                    <span className="checkmark">✔️</span>
                    <span className="feature-text">{feature}</span>
                  </li>
                ))}
              </ul>
              <button
                onClick={() => handlePurchase(plan.name)}
                className="purchase-button1"
              >
                Pick Up
              </button>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Subscription;
